export function formatCurrency(unitAmount: number | null | undefined, currency: string | null | undefined): string | null {
    if (typeof unitAmount !== 'number' || !Number.isFinite(unitAmount)) {
        return null;
    }

    const normalizedCurrency = (currency ?? '').trim().toUpperCase();
    if (!normalizedCurrency) {
        return null;
    }

    try {
        const locales = typeof navigator !== 'undefined' && navigator.languages.length > 0 ? navigator.languages : undefined;
        const formatter = new Intl.NumberFormat(locales, {
            style: 'currency',
            currency: normalizedCurrency,
        });
        const fractionDigits = formatter.resolvedOptions().maximumFractionDigits ?? 2;
        return formatter.format(unitAmount / (10 ** fractionDigits));
    } catch {
        return null;
    }
}
